import React from 'react';

// The +20 event-creation pitch shown at the end of BOTH signup flows (free → SignUpSuccess,
// paid → ManageSubscription after checkout). Text only / no box so it blends into the surrounding
// dark card — each surface renders its own "Create an Event" button (styled to match that surface)
// right above its primary action button.
function EventBonusOffer() {
    return (
        <div style={{margin: "30px auto 0 auto", maxWidth: "420px", textAlign: "center"}}>
            <h2 style={{fontFamily: "Chelsea Market, cursive", marginTop: "0px", color: "#ED9594", fontSize: "20px"}}><u><span role="img" aria-label="">⚡️</span> Wait! Don't Miss This:</u></h2>
            <p style={{fontSize: "12px", color: "white"}}>Now's your chance to earn an additional <strong>+20 Power Level</strong> boost to your profile by creating your first event! It can be anything — a boba meetup, anime watch party, game night, date night, or even a Discord hangout. If you can think it, you can create it!</p>
            <p style={{fontSize: "10px", color: "#999"}}>Limited-time bonus — create your first event now!</p>
        </div>
    );
}

export default EventBonusOffer;
